import { InferType, object } from 'yup';
import zxcvbn from 'zxcvbn';
import { Nullable } from '../../../model/common';
import { safeString } from './common';

export const resetPasswordSchema = object({
    current_password: safeString().required('Current Password can not be empty.'),
    new_password: safeString().required('New Password can not be empty.'),
    confirm_new_password: safeString()
        .required('Confirm Password can not be empty.')
        .test('passwords-match', 'Confirm Password does not match with the New Password.', function (value) {
            return this.parent.new_password === value;
        })
});

export type ResetPasswordFormValues = InferType<typeof resetPasswordSchema>;
export type ResetPasswordFormInput = Nullable<ResetPasswordFormValues>;

type ChangePasswordSchemaProps = {
    passwordRegex: RegExp;
    passwordComplexity: number;
    isReset: boolean;
    sanitizedInputs: string[];
};
export const changePasswordSchema = ({
    isReset,
    passwordComplexity,
    passwordRegex,
    sanitizedInputs
}: ChangePasswordSchemaProps) =>
    object({
        currentPassword: safeString().when([], {
            is: () => !isReset,
            then: (schema) => schema.required('Please enter your current password.'),
            otherwise: (schema) => schema.notRequired()
        }),
        newPassword: safeString()
            .required('Please enter your new password.')
            .matches(passwordRegex, {
                message: 'Please enter the correct password format'
            })
            .test('password-complexity', `Password complexity must be at least ${passwordComplexity}.`, (value) => {
                if (!value) return false;
                const complexity = zxcvbn(value, sanitizedInputs).score;
                return complexity >= passwordComplexity;
            }),
        confirmNewPassword: safeString()
            .required('Please confirm your new password.')
            .when('newPassword', (newPassword: string, schema) => schema.oneOf([newPassword], 'Passwords must match'))
    });

export type ChangePasswordFormValues = InferType<ReturnType<typeof changePasswordSchema>>;
export type ChangePasswordFormInput = Nullable<ChangePasswordFormValues>;
